import { render, staticRenderFns } from "./towerRace.vue?vue&type=template&id=18917c1f&"
import script from "./towerRace.vue?vue&type=script&lang=js&"
export * from "./towerRace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports